export const LISTE_PER_PAGE = 'liste_per_page';
export const ADDITIONAL_FIELDS = 'additional_fields';
